import firebase from 'firebase'

const trackingLinkRef = (id: string) => firebase.firestore().doc(`trackingLinks/${id}`)

export const deleteTrackingLink = (id: string) => trackingLinkRef(id).delete()

export type TrackingLinkType = {
    createdAt: number
    id: string
    uid: string
    orgId: string
    playbookId: string
    name: string
    domain?: string
}

export const createTrackingLink = (id: string, data: TrackingLinkType) => {
    return trackingLinkRef(id).set(data)
}
